import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import services from 'core/services';

import { PureComponent, Serialize, GroupBox } from 'core/components';
import { Icon, Stepper, Link, Col, Row, CardContent, CardFooter } from 'core/components/Framework7';
import { addToCart, changeCountItem, deleteItem } from 'content/pages/Cart/Module';

import classes from './styles.module.css';

const Price = Serialize.Price

class CartItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      item: this.initialValue,
      currentValue: props.item.count,
      latestValue: props.item.count,
    }

    this.debouncedHandleStepper = debounce(this.handleChangeStepper, 500);

    this.stepperElm = React.createRef()
  }

  static get defaultProps() {
    return {
      readOnly: false
    }
  }

  get initialValue() {
    return this.parseCartItem()
  }

  /**
   * parse item of category
   * @param {Object} item 
   */
  parseCartItem() {
    const { item, env } = this.props;
    const noPhoto = env && env.layout.assets.images.noPhoto

    return {
      id: item.id,
      alt: item.product ? item.product.cover ? item.product.cover.title : null : null,
      url: (item.product && item.product.cover && services.utils.url.image(item.product.cover, 4)) || noPhoto,
      name: item.product && item.product.name,
      link: item.id,
      childrenType: item.childrenType,
      currentPrice: item.product ? item.product.currentPrice : null,
      currentDiscount: item.product ? item.product.currentDiscount : 0,
      consumerPrice: item.product ? item.product.consumerPrice : null,
      count: item.count,
      productId: item.product ? item.product.id : null,
      quantity: item.product ? item.product.quantity : 0,
      unitType: item.product ? item.product?.unitType : null,
      limitBuyQuantity: item.product ? item.product?.limitBuyQuantity : 0
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const prevItem = prevState.item
    const currItem = this.initialValue
    // console.log('prevItem:', prevItem, ', currItem:', currItem)

    if (prevItem.count != currItem.count)
      this.handleCurrentValue()
  }

  changeStepper(value) {
    // console.log('changeStepper value:', value)
    if (this.state.currentValue == value) return

    this.setState({
      currentValue: value,
    }, () => {
      this.debouncedHandleStepper();
    })
  }

  //handle error bayad anjam shavad
  handleChangeStepper() {
    // console.log("handleChangeStepper");
    const { item, currentValue } = this.state;
    // console.log("item in cart", item);
    const minimumValue = item.unitType ? item.unitType.minimumValue : 0;
    // console.log("minimumValue in cart", minimumValue);


    this.setState({ loading: true })

    const params = {
      store: 2,
      errorHandler: true
    }

    if (currentValue < minimumValue)
      return this.deleteItem(item.id)

    return this.props.changeCountItem(item.id, { count: currentValue }, params)
      .then(r => { this.handleCurrentValue() })
      .catch(this.handleAPICatch)
      .finally(r => { this.setState({ loading: false }) })
  }

  deleteItem(itemId) {
    this.$f7.dialog.confirm("آیا از حذف کالا اطمینان دارید؟", "حذف",
      () => {
        this.$f7.dialog.preloader('در حال ارسال اطلاعات');
        this.deleteCartItem(itemId)
          .finally(r => {
            this.$f7.dialog.close()
          })
      },
      () => {
        this.$f7.dialog.close()
        this.handleAPICatch()
      }
    )
  }

  deleteCartItem(itemId) {
    return this.props.deleteItem(itemId, { store: 2 })
      .then(r => { this.handleCurrentValue() })
      .catch(this.handleAPICatch)
      .finally(r => { this.setState({ loading: false }); })
  }

  handleCurrentValue() {
    const item = this.initialValue;
    const value = item.count

    // console.log('item count:', value, 'latestValue:', this.state.latestValue, 'currentValue:', this.state.currentValue)
    // console.log('handleCurrentValue => ', item)

    this.setState(prevState => ({
      item: item,
      latestValue: value ? prevState.currentValue : 0,
      currentValue: value,
    }))
  }

  handleAPICatch(err) {
    const msg = (err && err.message) || ''
    const outOfStock = msg.indexOf("insufficient stock quantity") == 0
    if (outOfStock) {
      this.$f7.dialog.alert('تعداد کالای انتخابی از موجودی فروشگاه بیشتر است.', 'خطا')
    } else {
      this.$f7.dialog.alert('خطایی رخ داده، لطفا دوباره تلاش کنید', 'خطا');
    }

    this.setState(prevState => ({
      currentValue: outOfStock && prevState.latestValue > prevState.currentValue ? prevState.currentValue : prevState.latestValue,
      loading: false,
    }), () => {
      if (this.stepperElm.current)
        this.stepperElm.current.setValue(this.state.currentValue)
    })
  }

  render() {
    const { readOnly } = this.props;
    const { item, currentValue, loading } = this.state;
    const unitType = item.unitType;
    const { limitBuyQuantity, quantity } = item;
    let maxValue = (limitBuyQuantity && limitBuyQuantity > 0) ? Math.min(limitBuyQuantity, quantity, unitType?.maximumValue) : Math.min(quantity, unitType?.maximumValue);


    return (
      <GroupBox outline>
        <CardContent>
          <Row className={item.count > item.quantity ? classes.productUnavailable : ''}>
            <Col width="30" className={classes.productImage}>
              <Link href={readOnly ? false : `/product/${item.productId}`}>
                <img src={item.url} alt={item.name} />
              </Link>
            </Col>
            <Col width="50">
              <div className={classes.titleProduct}>{item.name}</div>
              <div className={classes.discountPrice}>
                {item.currentDiscount > 0 ?
                  <React.Fragment>
                    <del><Price price={item.currentPrice} hasExtension={false} /></del>
                    <p className={classes.discountFlag}>{'٪'}{Math.floor(item.currentDiscount)} {false && 'تخفیف'}</p>
                  </React.Fragment>
                  :
                  ' '
                }
              </div>
              <div className={classes.price}>
                <Price price={item.consumerPrice} />
              </div>
            </Col>
            <Col width="20">
              <p className={classes.discountP}>جمع تخفیف</p>
              <p className={classes.sumDiscountPrice}>{item.currentDiscount > 0 ? <Price price={(item.currentPrice * item.count) * item.currentDiscount / 100} /> : 0}</p>
              <p className={classes.discountP}>جمع پرداخت</p>
              <p className={classes.sumPrice}><Price price={item.consumerPrice * item.count} /></p>
            </Col>
          </Row>
          {item.count > item.quantity &&
            <Row>
              <Col width="100" className={classes.noQuantity}>
                {'تعداد کالای انتخابی بیشتر از موجودی فروشگاه است.'}
              </Col>
            </Row>
          }
        </CardContent>
        {readOnly &&
          <CardFooter>
            <Row>
              <Col width="60" />
              <Col width="40">
                <div className={classes.productCountContainer}>
                  <span className={`${classes.sumPrice} ${classes.productCount}`}>{item.count}</span>
                </div>
              </Col>
            </Row>
          </CardFooter>
        }
        {!readOnly &&
          <CardFooter>
            <Row>
              <Col width={item.count <= item.quantity ? "10" : "55"} >
                <Link className={classes.trash} onClick={(e) => this.deleteItem(item.id)}>
                  <Icon icon="mdi-trash-can-outline" />
                  {item.count > item.quantity && false &&
                    <span>
                      {'این تعداد کالا موجود نیست'}
                    </span>
                  }
                </Link>
              </Col>
              <Col width={item.count <= item.quantity ? "50" : "5"}></Col>
              <Col width="40">
                <Stepper
                  ref={this.stepperElm}
                  className={classes.stepper}
                  disabled={loading}
                  input={false}
                  autorepeat={true}
                  value={currentValue}
                  step={unitType ? unitType.step : null}
                  max={maxValue ?? null}
                  onStepperChange={this.changeStepper}
                />
              </Col>
            </Row>
          </CardFooter>
        }
      </GroupBox>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    cart: state.Cart.cart,
  }),
  {
    addToCart,
    changeCountItem,
    deleteItem
  }
)(autobind(CartItem))